export default "__VITE_ASSET__l232Gb2d__"